import api from "@/network";

export default {
  state: {
    importInfo: [],
    stateImportInfo: true
  },

  getters: {
    importInfo(state) {
      return state.importInfo;
    }
  },

  actions: {
    async checkImportLogs({commit, getters}, payload) {
        const response = await api.get('import/check_log');
        commit('updateImportInfo', response?.data||[]);

        return response?.data||[];
    },

    async getImportLogs(context, payload) {
      let url = 'import/list?';
      if (payload.page > 1) {
          url = `${url}page=${payload.page}`

      }
      if (payload.per_page !== 0) {
          if (payload.page > 1) {
              url = `${url}&per_page=${payload.per_page}`
          } else {
              url = `${url}&per_page=${payload.per_page}`
          }
      }
      if (!!payload.settings) {
          url = `${url}&settings=${JSON.stringify(payload.settings)}`
      }
      return await api.get(url);
  }
  },

  mutations: {
    updateImportInfo(state, payload) {
      payload.forEach(newInfo => {
        const existingIndex = state.importInfo.findIndex(info => info.process_code === newInfo.process_code);
        if (existingIndex !== -1) {
          state.importInfo.splice(existingIndex, 1, {...state.importInfo[existingIndex], ...newInfo});
        } else {
          state.importInfo.push(newInfo);
        }
      });
    },
    removeImportInfo(state, item) {
      state.importInfo = state.importInfo.filter(info => info.process_code !== item.process_code);
    },
    setStateImportInfo(state, value) {
      state.stateImportInfo = value;
    },
  },
}